/* eslint-disable import/no-default-export */

import {handleMultilingual} from '@wix/wixstores-client-storefront-sdk';
import {ControllerParams} from '@wix/yoshi-flow-editor';
import {IWidgetController} from '@wix/native-components-infra/dist/src/types/types';
import {CartController} from './CartController';
import {ViewerContext} from '@wix/ecom-platform-storefront-common';
import {SPECS} from '../../domain/specs';

export const controller = (controllerParams: ControllerParams): IWidgetController => {
  const siteStore = controllerParams?.appData?.context.siteStore;
  let controllerClass: CartController | undefined;

  const getController = async () => {
    if (controllerClass) {
      return controllerClass;
    }
    await siteStore.loadClientConfig();
    controllerClass = new CartController(controllerParams);
    return controllerClass;
  };

  return {
    async pageReady() {
      try {
        await getController();

        const isMultilingualNeeded = () => {
          const viewerContext = new ViewerContext(
            controllerParams.controllerConfig,
            controllerParams.controllerConfig.essentials.experiments.enabled(SPECS.MoveCartToViewerContext)
              ? undefined
              : siteStore
          );

          if (viewerContext.isExperimentEnabled(SPECS.MoveCartToViewerContext)) {
            return controllerParams.controllerConfig.config.externalId && !viewerContext.isPrimaryLanguage();
          }

          const multilingualFields = siteStore.getMultiLangFields();
          return (
            controllerParams.controllerConfig.config.externalId &&
            multilingualFields &&
            !multilingualFields?.isPrimaryLanguage
          );
        };

        const shouldCallAppSettings = isMultilingualNeeded();

        await Promise.all([
          ...(shouldCallAppSettings ? [handleMultilingual(controllerParams, controllerClass.getFreeTexts())] : []),
          controllerClass.init(),
        ]);
        controllerParams.controllerConfig.wixCodeApi.location.onChange(() => void controllerClass.load());
      } catch (error) {
        console.error(error);
        controllerParams.controllerConfig.setProps({generalError: true});
        controllerParams.appData.reportError(error);
      }
    },
    exports() {
      return getExportsAfterControllerLoaded(getController, ['hideSecureCheckout', 'showSecureCheckout']);
    },
    updateConfig: (_$w, updatedConfig: {[key: string]: any}): void => {
      return void controllerClass?.onStyleUpdate?.(updatedConfig.style.styleParams);
    },
  };
};

function getExportsAfterControllerLoaded(getController: () => Promise<CartController>, keys: string[]) {
  return keys.reduce((acc, key) => {
    acc[key] = async (...args: any[]) => {
      const controllerClass = await getController();
      return controllerClass.exports()[key](...args);
    };
    return acc;
  }, {});
}

export default controller;
